import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import AdminUsersManagement from './AdminUsersManagement';
import AdminTeamsPage from './AdminTeamsPage';
import NotificationSettings from '../Settings/NotificationSettings';
import SnoozeSettings from '../Settings/SnoozeSettings';
import AlertRoutingSettings from '../Settings/AlertRoutingSettings';
import AdminNotificationTest from './AdminNotificationTest';
import AdminOrganizationSettings from './AdminOrganizationSettings';
import StakeholderGroupsPage from '../Settings/StakeholderGroupsPage';
import QueryHistoryPage from './QueryHistoryPage';
import CostMonitoringPage from './CostMonitoringPage';
import QueryPerformancePage from './QueryPerformancePage';
import { useUI } from '../../contexts/UIContext';

const AdminSettingsPage = () => {
  const location = useLocation();
  const { updateBreadcrumbs } = useUI();

  // Determine active tab from URL path
  const getActiveTabFromPath = useCallback(() => {
    const path = location.pathname;
    if (path.includes('/teams')) return 'teams';
    if (path.includes('/stakeholder-groups')) return 'stakeholder-groups';
    if (path.includes('/notification-test')) return 'notification-test';
    if (path.includes('/snoozed-alerts')) return 'snoozed-alerts';
    if (path.includes('/alert-routing')) return 'alert-routing';
    if (path.includes('/notifications')) return 'notifications';
    if (path.includes('/organization')) return 'organization';
    if (path.includes('/query-history')) return 'query-history';
    if (path.includes('/cost-monitoring')) return 'cost-monitoring';
    if (path.includes('/query-performance')) return 'query-performance';
    return 'users';
  }, [location.pathname]);

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  // Update active tab when location changes
  useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location.pathname, getActiveTabFromPath]);

  // Clear breadcrumbs when the page loads to use path-based breadcrumbs
  useEffect(() => {
    updateBreadcrumbs([]);
  }, [updateBreadcrumbs]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'teams':
        return <AdminTeamsPage />;
      case 'stakeholder-groups':
        return <StakeholderGroupsPage />;
      case 'notification-test':
        return <AdminNotificationTest />;
      case 'notifications':
        return <NotificationSettings />;
      case 'snoozed-alerts':
        return <SnoozeSettings />;
      case 'alert-routing':
        return <AlertRoutingSettings />;
      case 'organization':
        return <AdminOrganizationSettings />;
      case 'query-history':
        return <QueryHistoryPage />;
      case 'cost-monitoring':
        return <CostMonitoringPage />;
      case 'query-performance':
        return <QueryPerformancePage />;
      case 'users':
      default:
        return <AdminUsersManagement />;
    }
  };

  return (
    <AdminLayout activeTab={activeTab} onTabChange={handleTabChange}>
      {renderTabContent()}
    </AdminLayout>
  );
};

export default AdminSettingsPage;